import React from 'react'
import { useSelector } from 'react-redux'
import Theme from '@refera/ui-core'

import { Grid, Typography } from '@mui/material'
import { Controller, useFormContext } from 'react-hook-form'

import { getCompartmentListSelector } from '_/modules/service-orders/selectors'

import { AutocompleteV2 } from '_/components/autocomplete-v2'

import useStyles from '../styles'
import { useBudgetForm } from '_/views/budget-view-v2/hooks/use-budget-form'

const NAME = 'compartment'

export function CompartmentField() {
  const styles = useStyles()

  const compartmentList = useSelector(getCompartmentListSelector)

  const { addProblemReadOnly } = useBudgetForm()
  const {
    control,
    formState: { errors },
  } = useFormContext()

  return (
    <Grid className={styles.compartmentContainer}>
      <Typography
        className={styles.label}
        style={{ color: !!errors?.compartment && Theme.Colors.Red.Base }}
      >
        Cômodo
        <span className={styles.required}>*</span>
      </Typography>
      <Controller
        name={NAME}
        control={control}
        render={field => (
          <AutocompleteV2
            {...field}
            variant="standard"
            options={compartmentList}
            placeholder="Cômodo"
            style={{ width: '100%' }}
            error={errors?.compartment?.message || errors?.compartment?.label?.message}
            disabled={addProblemReadOnly}
            required
          />
        )}
      />
    </Grid>
  )
}
